import { createFileRoute } from '@tanstack/react-router';
import { BenefitsListPage } from './BenefitsListPage';

export const Route = createFileRoute('/_protected/admin/benefits/')({
  component: BenefitsListPage,
});
